import styled, { createGlobalStyle } from "styled-components";
import { Caption1 } from "../../styles/typography";

export const TipTapStyles = createGlobalStyle`
  .ProseMirror {
    min-height: 320px;
    font-family: 'Inter', sans-serif;
    font-size: 19px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    color: inherit;
    padding: 16px;
    box-sizing: border-box;
    outline: none;

    strong { font-weight: 700; }
    em { font-style: italic; }
    u { text-decoration: underline; }

    ul, ol { padding-left: 1.5em; }
    ul { list-style-type: disc; }
    ol { list-style-type: decimal; }

    blockquote {
      padding: 0.5em;
      border-left: 4px solid rgb(${(props) => props.theme.colors.neutral150});
    }

    .is-editor-empty:first-child::before,
    p.is-editor-empty::before {
      content: attr(data-placeholder);
      float: left;
      color: rgb(${(props) => props.theme.colors.neutral150});
      pointer-events: none;
      height: 0;
    }
  }

  .ProseMirror-focused { outline: none; }

  .node-image.ProseMirror-selectednode {
    border-radius: 8px;
    outline: 2px solid rgb(${(props) => props.theme.colors.neutral600});
    outline-offset: 4px;
  }
`;

export const ToolbarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  background: rgb(${(props) => props.theme.colors.offWhite});
  position: sticky;
  top: 74px;
  z-index: 10;
  border-radius: 8px 8px 0 0;
`;

export const EditorBox = styled.div`
  flex: 1;
  overflow-y: auto;
  cursor: text;
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  border-top: none;
  display: grid;
`;

export const EditorWrapper = styled.div`
  min-height: 320px;
  align-self: stretch;

  display: inline-grid;

  p + p {
    margin-top: 0.75em;
  }
  .tiptap p.is-editor-empty:first-child::before {
    color: rgb(${(props) => props.theme.colors.neutral150});
    content: attr(data-placeholder);
    float: left;
    height: 0;
    pointer-events: none;
  }
`;

export const Datewrap = styled.div`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ToolbarButton = styled.button`
  border-radius: 4px;
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  height: 32px;
  min-width: 32px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: rgb(
    ${(props) =>
      props.$active
        ? props.theme.colors.neutral600
        : props.theme.colors.neutral200}
  );
  background-color: rgb(${(props) => props.theme.colors.white});
  cursor: pointer;
  box-shadow: ${(props) =>
    props.$active
      ? `rgba(${props.theme.colors.neutral200}, 0.1) 0px 4px 8px -4px inset`
      : "none"};
  transition:
    background 0.1s,
    border-color 0.1s;

  &:hover:not(:disabled) {
    border-color: rgb(${(props) => props.theme.colors.neutral400});
    color: rgb(${(props) => props.theme.colors.neutral400});
  }
  &:active {
    transform: scale(0.98);
  }
  border-color: rgb(
    ${(props) =>
      props.$active
        ? props.theme.colors.neutral600
        : props.theme.colors.neutral150}
  );

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  @media screen and (max-width: 600px) {
    ${Caption1} {
      display: none;
    }
  }

  transition: all 0.1s ease-in-out;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgb(${(props) => props.theme.colors.neutral400});
  }
`;

export const ToolbarDivider = styled.div`
  width: 2px;
  height: 20px;
  background-color: rgb(${(props) => props.theme.colors.neutral150});
  margin: 0 4px;
`;

export const DateLabel = styled.label`
  font-family: "Inter";
  font-size: 17px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const StyledDateInput = styled.input`
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-weight: 400;
  color: rgb(${(props) => props.theme.colors.neutral600});
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  border-radius: 8px;
  padding: 8px 12px;
  outline: none;
  background: rgb(${(props) => props.theme.colors.white});
  cursor: pointer;

  &:focus {
    border-color: rgb(${(props) => props.theme.colors.neutral600});
  }
`;

export const SeasonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

export const SeasonCheckbox = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: rgb(${(props) => props.theme.colors.neutral600});
`;

export const SeasonLabel = styled.label`
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: rgb(${(props) => props.theme.colors.neutral200});
  cursor: pointer;
`;

export const SeasonSelect = styled.select`
  font-family: "Inter", sans-serif;
  font-size: 17px;
  font-weight: 400;
  color: rgb(${(props) => props.theme.colors.neutral600});
  border: 2px solid rgb(${(props) => props.theme.colors.neutral150});
  border-radius: 8px;
  padding: 8px 12px;
  outline: none;
  background: rgb(${(props) => props.theme.colors.white});
  cursor: pointer;

  &:focus {
    border-color: rgb(${(props) => props.theme.colors.neutral600});
  }
`;
